/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { SnackbarProvider } from 'notistack'
import { KTCard, KTSVG } from '../../../../../../../../../_metronic/helpers'
import { Column } from 'react-table'
import { KTable, KTableHeader, KTableLoading } from '../../../../../../../components/UI'
import { KTableProvider, useKTable } from '../../../../../../../contexts/KTableProvider'

const TableDeliveryClothes: FC = () => {

  const { data, loading } = useKTable()
  const columns: Column<any>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Ropa Cama' />,
      accessor: 'tipoRopaCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Stock' />,
      accessor: 'FechaPeriodoFin',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'Cliente_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Módulo' />,
      accessor: 'Campamento_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Piso' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Editar' />,
      id: 'actions',
      Cell: ({ ...props }) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => console.log("selectEdit")}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={data} columns={columns} />
      </KTCard>
    </>
  )
}

const TableDeliveryClothesWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableDeliveryClothes />
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export { TableDeliveryClothesWrapper }
